async function loadSemanticJs() {
  await import(/* webpackChunkName: "semantic-js" */ './semantic.js');
}

async function loadSemanticCss() {
  const semanticCss = await import(/* webpackChunkName: "semantic-css" */ './semantic.min.css');
  const styleElm = document.createElement('style');
  styleElm.innerHTML = semanticCss.default;
  document.head.appendChild(styleElm);
}

export function loadSemantic() {
  return Promise.all([loadSemanticJs(), loadSemanticCss()]);
}
